import { catchError, map, of } from "rxjs";
import { LocalStorage } from "@shared/services/storages/local-storage";
import { AuthService } from '@app/auth/auth.service';

export function authFactory(authService: AuthService) {
  return () => {
    if (LocalStorage.get('access')) {
      return authService.getMe().pipe(catchError(() => of(true)), map(() => true));
    } else {
      return of(true);
    }
  }
}

